<template>
  <div class="share-button mx-3">
    <el-button
        type="primary"
        @click="toggleShareSection"
        class="m-1">
      Share Response
    </el-button>
    <div v-if="showShareSection" class="share-section">
      <input type="text" class="form-control" placeholder="Click generate button for link" v-model="link">
      <input type="text" class="form-control" placeholder="Email Recipient" v-model="emailRecipient">
       <app-input
        type="file"
        :label="$t('attachment')"
        v-model="attachmentPdf"
      />
      <textarea placeholder="Text for Email" class="form-control" v-model="textForEmail"></textarea>
      <!-- <button @click="generate" class="btn btn-success">Generate</button> -->
      <!-- <button @click="send" class="btn btn-dark">Send</button> -->
      <app-input
          type="single-checkbox"
          :list-value-field="$t('bcc_msg')"
          v-model="bcc"
      />
      <el-switch v-model="setExpiry"
                 active-text="Set link expiration"
                 inactive-text="No Expiry"/>
      <input v-if="setExpiry" type="date" class="form-control" placeholder="Set Expiry" v-model="linkExpiry">
      <el-switch v-model="setPassword"
                 active-text="Protect link by password"
                 inactive-text="No password"/>
      <input v-if="setPassword" type="password" class="form-control" placeholder="Password" v-model="linkPassword">

      <app-load-more
        :preloader="preloaderLink"
        :label="$t('Generate')"
        type="submit"
        class-name="btn btn-success"
        @submit="generate"
      />
      <app-load-more
        :preloader="preloaderSend"
        :label="$t('Send')"
        type="submit"
        class-name="btn btn-primary"
        @submit="send"
      />
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";

import {axiosPost} from "@/app/Helpers/AxiosHelper";
import {SHARE_RESPONSE_MAIL} from "@/app/Config/ApiUrl";

export default {
  mixins: [FormMixin],
  name: "ShareResponse",
  data() {
    return {
      bcc: false,
      preloaderLink: false,
      preloaderSend: false,
      showShareSection: false,
      link: '',
      linkPassword: '',
      linkExpiry: '',
      setExpiry: false,
      setPassword: false,
      emailRecipient: '',
      textForEmail: 'I hope this email finds you well.\n' +
          '\n' +
          'I am writing to share my responses to the form you provided. Below is a summary of my responses:\n' +
          '\n',
      info: {},
      attachmentPdf: null,
    };
  },
  methods: {
    toggleShareSection() {
      this.showShareSection = !this.showShareSection;
    },
    generate() {
      // Add your logic for generating the share link
      let currentUrl = this.$store.state.sharedData.sharedData.formPreviewUrl;
      this.preloaderLink = true;
      let postData = {
        currentUrl: currentUrl,
        expiry: this.linkExpiry,
        password: this.linkPassword
      };
      axiosPost('/generate-preview-link', postData)
          .then((res) => {
            this.$toastr.s(res.data.message);
            this.link = res.data.link;

            this.info.user_id = res.data.info.user_id;
            this.info.form_id = res.data.info.form_id;

            this.preloaderLink = false;
          })
          .catch((error) => {
            this.$toastr.e(error.response.data.message ?? error.message);
          }).finally(() => {

      });
    },
    send() {
      // Add your logic for sending the email
      if (this.link == ''){
        this.$toastr.e('No link generated, Please click to generate a new link');
      }
      else if(this.emailRecipient == '')
      {
        this.$toastr.e('Email Recipient field is empty');
      }
      else {

        this.preloaderSend = true;
        var data = {
          email: this.emailRecipient,
          message: this.textForEmail,
          link: this.link,
          linkExpiry: this.linkExpiry,
          linkPassword: this.linkPassword,
          user_id: this.info.user_id,
          form_id: this.info.form_id,
          attachmentPdf: this.attachmentPdf,
          bcc: this.bcc,
        };

        let formData = new FormData;
          for (const [key, value] of Object.entries(data)) {
              formData.append(key, value);
          }

        axiosPost(SHARE_RESPONSE_MAIL, formData)
            .then((res) => {
              this.$toastr.s(res.data.message);

              this.emailRecipient = '';
              this.textForEmail = ''
              this.preloaderSend = false;
              // this.showShareSection = false;
            })
            .catch((error) => {
              this.$toastr.e(error.response.data.message ?? error.message);
              this.preloaderSend = false;

            }).finally(() => {

        });
      }
    }
  }
};
</script>

<style>
.share-button {
  position: relative;
  display: inline-block;
}

.share-section {
  position: absolute;
  bottom: 30px; /* Adjust as needed */
  left: 0;
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 400px;
}
.custom-file .custom-file-label{
  text-align: left !important;
}
</style>